import { createSelector, createSlice } from '@reduxjs/toolkit';
import {
    getCropNutrition,
    getCropNutritionDetail,
    getCropsForProductByTypeAndTrialsCountry,
} from 'api/CropNutritionPrograms';
import { fetchWithLanguage } from 'store/helpers';

export const fetchCropNutrition = fetchWithLanguage('fetchCropNutrition', getCropNutrition);
export const fetchCropNutritionDetail = fetchWithLanguage('fetchCropNutritionDetail', getCropNutritionDetail);
export const fetchCropNutritionForProduct = fetchWithLanguage(
    'fetchCropNutritionForProduct',
    getCropsForProductByTypeAndTrialsCountry,
);

const cropNutritionSlice = createSlice({
    name: 'cropNutritionSlice',
    initialState: {
        cropNutrition: {},
        cropNutritionDetail: {},
        cropNutritionForProduct: {},
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchCropNutrition.fulfilled, (state, action) => {
                state.cropNutrition = action.payload;
            })
            .addCase(fetchCropNutritionDetail.fulfilled, (state, action) => {
                state.cropNutritionDetail = action.payload;
            })
            .addCase(fetchCropNutritionForProduct.fulfilled, (state, action) => {
                state.cropNutritionForProduct = action.payload;
            });
    },
});

export const selectCropNutritionPage = createSelector(
    [state => state.cropNutritionState.cropNutrition],
    cropNutrition => cropNutrition.data || {},
);

export const selectCropNutritionDetail = createSelector(
    [state => state.cropNutritionState.cropNutritionDetail],
    cropNutritionDetail => cropNutritionDetail.data || {},
);

export const selectCropNutritionForProduct = createSelector(
    [state => state.cropNutritionState.cropNutritionForProduct],
    cropNutritionForProduct => cropNutritionForProduct || {},
);

export default cropNutritionSlice.reducer;
